/**
 * Requisiti di una password, per dire subito cosa manca mentre la si scrive.
 *
 * Gli stessi di backend/src/api/passwordPolicy.ts, che e' quello che decide:
 * qui servono solo a non far scoprire l'errore dopo aver premuto il pulsante.
 * Se cambiano, vanno cambiati tutti e due.
 */

export const LUNGHEZZA_MINIMA_PASSWORD = 8;

const REQUISITI: readonly { etichetta: string; soddisfatto: (p: string) => boolean }[] = [
  {
    etichetta: `almeno ${LUNGHEZZA_MINIMA_PASSWORD} caratteri`,
    soddisfatto: (p) => p.length >= LUNGHEZZA_MINIMA_PASSWORD,
  },
  { etichetta: 'una maiuscola', soddisfatto: (p) => /\p{Lu}/u.test(p) },
  { etichetta: 'una minuscola', soddisfatto: (p) => /\p{Ll}/u.test(p) },
  { etichetta: 'un numero', soddisfatto: (p) => /\p{Nd}/u.test(p) },
  { etichetta: 'un carattere speciale', soddisfatto: (p) => /[^\p{L}\p{N}\s]/u.test(p) },
];

export function requisitiMancanti(password: string): string[] {
  return REQUISITI.filter((r) => !r.soddisfatto(password)).map((r) => r.etichetta);
}
